const groups: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "内容导航",
    links: [
      { label: "今日瓜点", href: "#today" },
      { label: "最新爆料", href: "#hot" },
      { label: "实时热搜榜", href: "#trend" },
      { label: "深度解读", href: "#deep" },
    ],
  },
  {
    title: "站内栏目",
    links: [
      { label: "明星动态", href: "#category" },
      { label: "影视综艺", href: "#category" },
      { label: "社会热点", href: "#category" },
      { label: "网红世界", href: "#category" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "我要爆料", href: "#report" },
      { label: "内容原则", href: "#about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-950 text-background-300">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 font-display text-lg font-bold text-background-50">
                99
              </span>
              <span className="font-display text-xl font-bold text-background-50">吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-400">
              99吃瓜 专注于整理今日瓜点、最新爆料与热门事件，
              让每一个蹲瓜的人，都能看得清楚、吃得起劲、也保持理性。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2 text-xs text-background-400">
              <span className="flex items-center gap-1.5 rounded-full border border-background-800 px-3 py-1.5">
                <i className="ri-mail-line h-3.5 w-3.5 flex items-center justify-center text-accent-400" />
                contact@99chigua.example
              </span>
              <span className="flex items-center gap-1.5 rounded-full border border-background-800 px-3 py-1.5">
                <i className="ri-earth-line h-3.5 w-3.5 flex items-center justify-center text-accent-400" />
                全天候 24h 跟进
              </span>
            </div>
          </div>

          {groups.map((g) => (
            <nav key={g.title} aria-label={g.title} className="md:col-span-2">
              <h4 className="text-sm font-semibold text-background-50">{g.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-background-400 transition-colors hover:text-accent-400"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50">免责与边界声明</h4>
            <p className="mt-4 text-xs leading-relaxed text-background-500">
              本平台内容综合公开网络信息整理而成，带有“网传”“最新爆料”等标注的条目尚未获得
              官方证实，仅供娱乐参考，请以当事人或相关机构正式发声为准。我们不传播未经证实的
              恶意揣测，坚决尊重隐私与未成年人权益。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-900 pt-6 text-xs text-background-500 sm:flex-row">
          <p>© 2026 99吃瓜 · 用心整理每一颗瓜</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line h-3.5 w-3.5 flex items-center justify-center text-accent-500" />
            理性吃瓜 · 尊重边界 · 有错即改
          </p>
        </div>
      </div>
    </footer>
  );
}